import React from "react";
import styles from "../utils/styles";

export default function Ribbon({ label }) {
  const classes = styles.useStyles();

  return <div className={classes.demoRibbon}>{label}</div>;
}
